import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import PageHero, { usePageMeta } from "@/components/marketing/PageHero";
import { Button } from "@/components/ui/button";
import { getWallets, getEligible } from "@/data/site";
import { useI18n } from "@/context/I18nContext";

export default function WalletDetail() {
  const { slug } = useParams();
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  const wallet = getWallets(lang).find((w) => w.slug === slug);
  usePageMeta(wallet ? `${wallet.name}` : L("Wallet", "Wallet", "Wallet"), wallet ? L(`Assistenza al recupero per wallet ${wallet.name}.`, `Recovery assistance for ${wallet.name} wallet.`, `Wiederherstellungshilfe für ${wallet.name}-Wallet.`) : "");
  if (!wallet) return <Navigate to="/wallet" replace />;
  const eligible = getEligible(lang);

  return (
    <div>
      <PageHero eyebrow={wallet.type} title={L(`Recupero accesso ${wallet.name}`, `${wallet.name} access recovery`, `${wallet.name}-Zugriffswiederherstellung`)}
        subtitle={L(`Analizziamo casi relativi a ${wallet.name} in base al materiale ancora disponibile. Nessuna seed phrase completa, chiave privata o PIN viene mai richiesta.`, `We analyze ${wallet.name} cases based on the material still available. No full seed phrase, private key or PIN is ever requested.`, `Wir analysieren ${wallet.name}-Fälle anhand der noch verfügbaren Unterlagen. Vollständige Seed-Phrasen, private Schlüssel oder PINs werden nie verlangt.`)}>
        <div className="mt-8">
          <Button asChild size="lg" className="bg-gold text-navy hover:bg-gold-hover" data-testid="wallet-detail-cta">
            <Link to="/avvia-recupero">{L("Richiedi una valutazione", "Request an assessment", "Bewertung anfragen")} <ArrowRight className="ml-2 h-4 w-4" /></Link>
          </Button>
        </div>
      </PageHero>
      <section className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-20">
        <h2 className="font-heading text-2xl font-medium text-white mb-6">{L("Situazioni che possiamo valutare", "Situations we can assess", "Situationen, die wir bewerten können")}</h2>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {eligible.map((e) => (
            <li key={e} className="flex items-center gap-2.5 rounded-lg border border-white/10 bg-navy-paper px-4 py-3 text-sm text-slate-300">
              <Check className="h-4 w-4 text-cyanx shrink-0" />{e}
            </li>
          ))}
        </ul>
        <p className="mt-8 text-sm text-slate-500">
          {L("La possibilità di recupero non è garantita e dipende dalla situazione tecnica specifica. Una seed phrase completamente persa, senza backup, file, chiave o dispositivo, è generalmente non recuperabile.", "Recovery is not guaranteed and depends on the specific technical situation. A fully lost seed phrase, with no backup, file, key or device, is generally unrecoverable.", "Eine Wiederherstellung ist nicht garantiert und hängt von der konkreten technischen Situation ab. Eine vollständig verlorene Seed-Phrase ohne Backup, Datei, Schlüssel oder Gerät ist in der Regel nicht wiederherstellbar.")}
        </p>
      </section>
    </div>
  );
}
